const getters = {
  expense(state) {
    return state.expense;
  },
  expenses(state) {
    return state.expenses;
  },
};

export default getters;
